import { UploadState } from './@types';

export function getAnaliseCoberturaModel(props, query, name, identificadores) {
  return {
    query: query || '',
    field: name || null,
    login: JSON.parse(localStorage.getItem('usuario'))?.email,
    cliente: JSON.parse(localStorage.getItem('cliente'))?.codigo,
    addNotFound: true,
    canal: props.filtrosData?.canal || ['Canal físico', 'Canal digital'],
    identificadores: identificadores || null,
    preco: props.filtrosData?.preco?.name ? { name: props.filtrosData.preco.name } : { name: 'PRECO_PAGO' },
    gtin: name && name === 'produto' ? null : props.produto?.length ? props.produto : null,
    rede: name && name === 'rede' ? null : props.rede?.length ? props.rede : null,
    uf: name && name === 'uf' ? null : props?.uf?.length ? props.uf : null,
    cidade: name && name === 'cidade' ? null : props?.cidade?.length ? props.cidade : null,
    loja: name && name === 'loja' ? null : props?.loja?.length ? props.loja : null,
    tipoLoja: name && name === 'tipoLoja' ? null : props?.tipoLoja?.length ? props.tipoLoja : null,
  };
}

export const setModalUploadStatus = (type, resp, set) => {
  const tableData = {
    dataEnvio: resp.data.dataEnvio,
    usuario: resp.data.usuario,
    nomeArquivo: resp.data.nomeArquivo,
  };

  if (resp.status === 400) {
    // Erro, ARQUIVO INVALIDO
    set('uploadState', UploadState.WRONG_FILE);
  }

  if (resp.status === 207 && resp.data.todosInvalidos) {
    // Erro, GTIN/LOJA totalmente INVALIDO
    set('uploadState', UploadState.ERROR);
  }

  if (resp.status === 207 && !resp.data.todosInvalidos) {
    // Erro, GTIN/LOJA parcialmente INVALIDO
    set('uploadState', UploadState.PARCIAL);
  }

  if (type === 'PRODUTO') {
    if (resp.status === 200) {
      set('openModalProductUpload', false);
      set('isProductNewFile', true);
      set('produtoTableData', tableData);
    }

    if (resp.status === 422 && resp.data === 'LIMITE_GTINS_EXCEDIDO') {
      // Limite de GTIN EXCEDIDO
      set('uploadState', UploadState.EXCEED);
    }
  } else {
    if (resp.status === 200) {
      set('openModalLojaUpload', false);
      set('isLojaNewFile', true);
      set('lojaTableData', tableData);
    }

    if (resp.status === 422 && resp.data === 'LIMITE_LOJAS_EXCEDIDO') {
      // Limite de LOJAS EXCEDIDO
      set('uploadState', UploadState.EXCEED);
    }
  }
};
